import interceptorAxios from './InterceptorAxios'

const ServicioHttp = {
    consumirPostHttp(url, datos) {
        return interceptorAxios.post(url, datos);
    }
}

export default ServicioHttp;